import { create } from 'zustand';

export type ZstdLoading = {
  cnt: number;
  inc: () => void;
  dec: () => void;
};
export const useZstdLoading = create<ZstdLoading>((set) => ({
  cnt: 0,
  inc: () => {
    set((state) => ({ cnt: state.cnt + 1 }));
  },
  dec: () => {
    set((state) => state.cnt > 0 && { cnt: state.cnt - 1 });
  },
}));
